// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  BatchTaskSubmissionTrainingDataRequest,
  BatchTrainingDataRequest,
  GenericApiResponseStr,
  HTTPValidationError,
} from '../../models';

/**
 * Export rubric training data for a specific task as CSV row
 * @summary Get Task Rubric Training Data
 */
export const getTaskRubricTrainingData = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStr>> => {
  return axios.get(`/ml/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/rubric-dataset`, options);
};

export const getGetTaskRubricTrainingDataQueryKey = (moduleId: string, moduleVersion: string, taskId: string) => {
  return [`/ml/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/rubric-dataset`] as const;
};

export const getGetTaskRubricTrainingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTaskRubricTrainingDataQueryKey(moduleId, moduleVersion, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskRubricTrainingData>>> = ({ signal }) =>
    getTaskRubricTrainingData(moduleId, moduleVersion, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && moduleVersion && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTaskRubricTrainingDataQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskRubricTrainingData>>>;
export type GetTaskRubricTrainingDataQueryError = AxiosError<HTTPValidationError>;

export function useGetTaskRubricTrainingData<
  TData = Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskRubricTrainingData<
  TData = Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskRubricTrainingData<
  TData = Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Task Rubric Training Data
 */

export function useGetTaskRubricTrainingData<
  TData = Awaited<ReturnType<typeof getTaskRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTaskRubricTrainingData>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTaskRubricTrainingDataQueryOptions(moduleId, moduleVersion, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export rubric training data for multiple tasks as complete CSV
 * @summary Get Batch Rubric Training Data
 */
export const getBatchRubricTrainingData = (
  batchTrainingDataRequest: BatchTrainingDataRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStr>> => {
  return axios.post(`/ml/rubric-dataset/batch`, batchTrainingDataRequest, options);
};

export const getGetBatchRubricTrainingDataMutationOptions = <
  TData = Awaited<ReturnType<typeof getBatchRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BatchTrainingDataRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['getBatchRubricTrainingData'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getBatchRubricTrainingData>>,
    { data: BatchTrainingDataRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getBatchRubricTrainingData(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BatchTrainingDataRequest },
    TContext
  >;
};

export type GetBatchRubricTrainingDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getBatchRubricTrainingData>>
>;
export type GetBatchRubricTrainingDataMutationBody = BatchTrainingDataRequest;
export type GetBatchRubricTrainingDataMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Get Batch Rubric Training Data
 */
export const useGetBatchRubricTrainingData = <
  TData = Awaited<ReturnType<typeof getBatchRubricTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BatchTrainingDataRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: BatchTrainingDataRequest }, TContext> => {
  const mutationOptions = getGetBatchRubricTrainingDataMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Export task submission evaluation training data as CSV row
 * @summary Get Task Submission Evaluation Training Data
 */
export const getTaskSubmissionEvaluationTrainingData = (
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStr>> => {
  return axios.get(
    `/ml/users/${userId}/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/evaluation-dataset`,
    options,
  );
};

export const getGetTaskSubmissionEvaluationTrainingDataQueryKey = (
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
) => {
  return [`/ml/users/${userId}/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/evaluation-dataset`] as const;
};

export const getGetTaskSubmissionEvaluationTrainingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTaskSubmissionEvaluationTrainingDataQueryKey(userId, courseId, moduleId, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>> = ({ signal }) =>
    getTaskSubmissionEvaluationTrainingData(userId, courseId, moduleId, taskId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && courseId && moduleId && taskId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTaskSubmissionEvaluationTrainingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>
>;
export type GetTaskSubmissionEvaluationTrainingDataQueryError = AxiosError<HTTPValidationError>;

export function useGetTaskSubmissionEvaluationTrainingData<
  TData = Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskSubmissionEvaluationTrainingData<
  TData = Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTaskSubmissionEvaluationTrainingData<
  TData = Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Task Submission Evaluation Training Data
 */

export function useGetTaskSubmissionEvaluationTrainingData<
  TData = Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
>(
  userId: string,
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTaskSubmissionEvaluationTrainingData>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTaskSubmissionEvaluationTrainingDataQueryOptions(
    userId,
    courseId,
    moduleId,
    taskId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export task submission evaluation training data for multiple task submissions as complete CSV
 * @summary Get Batch Task Submission Evaluation Training Data
 */
export const getBatchTaskSubmissionEvaluationTrainingData = (
  batchTaskSubmissionTrainingDataRequest: BatchTaskSubmissionTrainingDataRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseStr>> => {
  return axios.post(
    `/ml/evaluation-dataset/batch-by-task-submissions`,
    batchTaskSubmissionTrainingDataRequest,
    options,
  );
};

export const getGetBatchTaskSubmissionEvaluationTrainingDataMutationOptions = <
  TData = Awaited<ReturnType<typeof getBatchTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BatchTaskSubmissionTrainingDataRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['getBatchTaskSubmissionEvaluationTrainingData'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getBatchTaskSubmissionEvaluationTrainingData>>,
    { data: BatchTaskSubmissionTrainingDataRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getBatchTaskSubmissionEvaluationTrainingData(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BatchTaskSubmissionTrainingDataRequest },
    TContext
  >;
};

export type GetBatchTaskSubmissionEvaluationTrainingDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getBatchTaskSubmissionEvaluationTrainingData>>
>;
export type GetBatchTaskSubmissionEvaluationTrainingDataMutationBody = BatchTaskSubmissionTrainingDataRequest;
export type GetBatchTaskSubmissionEvaluationTrainingDataMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Get Batch Task Submission Evaluation Training Data
 */
export const useGetBatchTaskSubmissionEvaluationTrainingData = <
  TData = Awaited<ReturnType<typeof getBatchTaskSubmissionEvaluationTrainingData>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BatchTaskSubmissionTrainingDataRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: BatchTaskSubmissionTrainingDataRequest }, TContext> => {
  const mutationOptions = getGetBatchTaskSubmissionEvaluationTrainingDataMutationOptions(options);

  return useMutation(mutationOptions);
};
